import { useEffect, useState } from 'react';
import { desktop } from './desktop';

/**
 * هل تطبيقُ سطح المكتب نشطٌ على هذا الجهاز؟
 *
 * التطبيقُ حين يعمل يفتح منفذًا محلّيًّا (127.0.0.1:47831) للهاتف المقترن.
 * وجودُ ذلك المنفذ — نستفتيه بطلبِ حالةٍ — دليلٌ على أنّ التطبيقَ مثبَّتٌ
 * ويعمل، حتى لو فُتح النظامُ في المتصفّح لا في التطبيق. فيُغني عن تكرار
 * دعوةِ التنزيل لمن ثبّته، ويُعلمه أنّه نشط.
 *
 * الفحصُ مرّةً واحدةً لكلّ جلسة (يُذكَر)، بمهلةٍ قصيرة — لا يُبطئ الصفحة.
 */
const LOCAL_BRIDGE = 'http://127.0.0.1:47831/phone';
let probe: Promise<boolean> | null = null;

function probeLocal(): Promise<boolean> {
  if (!probe) {
    probe = fetch(LOCAL_BRIDGE, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'x-goyone': '1' },
      body: JSON.stringify({ cmd: 'status' }),
      signal: AbortSignal.timeout(2500),
    })
      .then((r) => r.ok)
      .catch(() => false);
  }
  return probe;
}

export interface DesktopPresence {
  /** التطبيقُ نشطٌ على الجهاز (في التطبيق نفسه أو مثبَّتٌ ويعمل في الخلفية). */
  active: boolean;
  /** النظامُ مفتوحٌ داخل التطبيق نفسِه الآن. */
  inApp: boolean;
  /** انتهى الفحصُ فصار الجوابُ مؤكَّدًا. */
  ready: boolean;
}

export function useDesktopPresence(): DesktopPresence {
  const inApp = !!desktop;
  const [active, setActive] = useState(inApp);
  const [ready, setReady] = useState(inApp);

  useEffect(() => {
    if (inApp) return;
    let stopped = false;
    void probeLocal().then((ok) => {
      if (stopped) return;
      setActive(ok);
      setReady(true);
    });
    return () => {
      stopped = true;
    };
  }, [inApp]);

  return { active: inApp || active, inApp, ready };
}
